<template>
  <form class="card-body" @submit.prevent="sms()">
    <h2 class="card-login-title">Введите код</h2>

    <div class="form-group">
      <label for="input-login-code">Код из сообщения SMS</label>
      <input
        id="input-login-code"
        type="text"
        class="form-control form-control-lg"
        placeholder="Код"
        v-model="code"
        v-focus
        ref="input"
      >
    </div>

    <div class="form-actions">
      <button class="btn btn-primary btn-lg btn-block" type="submit">Продолжить</button>
      <button class="btn btn-link btn-block" @click="$emit('cancel')" type="button">Назад</button>
    </div>

    <div class="alert alert-danger" :class="{ 'new': error_new } " v-if="error">{{ error }}</div>
  </form>
</template>

<script>
  import { extend } from 'lodash'
  import auth from '../../auth'

  export default {
    props: [],
    data () {
      return {
        code: '',
        error: '',
        error_new: false,
      }
    },
    methods: {
      sms () {
        if (!this.code) {
          this.$refs.input.focus()
          return
        }

        auth.sms({code: this.code})
          .then(() => {
            return this.$router.push('/')
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response)
              if (error.response.status === 404) {
                this.$emit('cancel') // No valid token found, start over
              } else if (error.response.status === 401) {
                this.error = 'Неверный код'
              } else {
                this.error = 'Ошибка при выполнении запроса'
              }
            } else {
              this.error = 'Ошибка при выполнении запроса'
            }
            // Highlight error
            this.error_new = true
            setTimeout(() => {
              this.error_new = false
            }, 100)
          })
      },
    },
  }
</script>

<style lang="scss">
  #input-login-code {
    font-size: 1.09375rem;
    padding: 0 .2em;
    line-height: 1.3;
    text-align: center
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/login/sms.vue